import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../../common/baseQuery';

// initialize an empty api service that we'll inject endpoints into later as needed
export const groupsApi = createApi({
  reducerPath: 'groupsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: () => ({})
});
